const MUSIC_CDN_HOST = 'd1vhqe85rj08c.cloudfront.net';
const COMPRESSED_MUSIC_CDN_HOST = 'd3aqxhqn7od95x.cloudfront.net';
const STORYBLOCK_AUDIO_CDN_HOST = 'd4avkergo7ay2.cloudfront.net';
const MUSIC_PREFIX = '/invideo-music/';
const COMPRESSED_AUDIO_PREFIX = '/compressed-audio/';

function parseHttpUrl(url: string) {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch (e) {
    return null;
  }
  if (!/^https?:$/.test(parsed.protocol) || parsed.pathname.length <= 1) {
    return null;
  }
  return { host: parsed.hostname.toLowerCase(), path: parsed.pathname, search: parsed.search };
}

// invideo-music and storyblock-audios CDN urls (keys without a bucket prefix)
// mapped to their compressed copies. Returns null for any other url.
export function toCompressedAudioCdnUrl(url: string): string | null {
  const parsed = parseHttpUrl(url);
  if (!parsed) {
    return null;
  }
  const { host, path, search } = parsed;
  if (host === MUSIC_CDN_HOST) {
    // '+' in the path is a space to S3; the compressed-music CDN needs %20
    return `https://${COMPRESSED_MUSIC_CDN_HOST}/invideo-music${path.replace(/\+/g, '%20')}${search}`;
  }
  if (host === STORYBLOCK_AUDIO_CDN_HOST && !path.startsWith(COMPRESSED_AUDIO_PREFIX)) {
    return `https://${STORYBLOCK_AUDIO_CDN_HOST}/compressed-audio${path}${search}`;
  }
  return null;
}

// Inverse of toCompressedAudioCdnUrl: the original of a compressed music or
// storyblock url, used when the compressed copy fails to load. Null otherwise.
export function toOriginalAudioCdnUrl(url: string): string | null {
  const parsed = parseHttpUrl(url);
  if (!parsed) {
    return null;
  }
  const { host, path, search } = parsed;
  if (host === COMPRESSED_MUSIC_CDN_HOST && path.startsWith(MUSIC_PREFIX)) {
    return `https://${MUSIC_CDN_HOST}/${path.slice(MUSIC_PREFIX.length)}${search}`;
  }
  if (host === STORYBLOCK_AUDIO_CDN_HOST && path.startsWith(COMPRESSED_AUDIO_PREFIX)) {
    return `https://${STORYBLOCK_AUDIO_CDN_HOST}/${path.slice(
      COMPRESSED_AUDIO_PREFIX.length,
    )}${search}`;
  }
  return null;
}
